import CloseIcon from "@mui/icons-material/Close";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, DialogContentText } from '@mui/material';
import { LoadingButton } from "@mui/lab";
import toast from "react-hot-toast";
import { apiCallGetsPaginated } from "../../utils/action";
const CLDeleteTags = ({ setDeleteLoader, deleteLoader, handleCloseConfirmationModal, deleteConfirmationModal, deletedTagId, setDeletedTagId, GetCommentLibTagList }) => {
    const companyId = sessionStorage.getItem("company_id");
    const handleDeleteTag =  () => {
        setDeleteLoader(true)
        const params = `?company_id=${companyId}`

        const payload = {
            "tag_id": deletedTagId,
        };
        apiCallGetsPaginated(
            (response) => {
                const { data, message, success } = response.data;
                if (success) {
                    toast.success(message);
                    GetCommentLibTagList()
                    handleCloseConfirmationModal(false);
                    setDeleteLoader(false)
                } else {
                    toast.error(message);
                    console.error("else", message);
                }
            },
            payload,
            "GET_CL_TAG",
            params,
            "DELETE"
        );
    }
    return (<Dialog
        open={deleteConfirmationModal}
        onClose={handleCloseConfirmationModal}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="delete-alert-modal"
        disableScrollLock
        keepMounted
    >
        <DialogTitle id="alert-dialog-title">
            {"Confirm Deletion?"}
            <CloseIcon className="close-icon" onClick={handleCloseConfirmationModal} />
        </DialogTitle>
        <DialogContent>
            <DialogContentText id="alert-dialog-description">
                Are you sure you want to delete this Tag? It will also be removed from the comments it is assigned to.
            </DialogContentText>
        </DialogContent>
        <DialogActions>
            <Button className='options' onClick={handleCloseConfirmationModal}><span>No</span></Button>
            <LoadingButton loading={deleteLoader} className='add-new-btn' onClick={handleDeleteTag}><span>Yes</span></LoadingButton>
        </DialogActions>
    </Dialog>)
}
export default CLDeleteTags;